import React from "react";
import { _post } from "../../Api";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";

export default function AddFloorplanDialog(props) {
  const dialogClose = props.dialogClose;
  const spMerchantId = Number.parseInt(useParams().spMerchantId);
  const [, setFloorplans] = props.floorPlans;
  const findCurrentMerchant = props.findMerchant;
  const getDialogState = props.dialogState;
  let floorplan_input;

  function addFloorplan() {
    const new_floorplan = {
      name: floorplan_input,
    };
    _post("/nova/sp_merchant/" + spMerchantId + "/floorplan", new_floorplan)
      .catch((e) => {
        toast.error("Addition of floor plan was unsuccessful.", {
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        setFloorplans(JSON.parse(findCurrentMerchant().floor_plan));
        console.log(e);
        return Promise.reject();
      })
      .then((response) => {
        toast.success("Added new floor plan successfully!", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        const sp_merchant = findCurrentMerchant();
        sp_merchant.floor_plan = response.data.floor_plan;
        setFloorplans([...JSON.parse(response.data.floor_plan)]);
        dialogClose();
      });
  }

  return (
    <Dialog open={getDialogState()} onClose={dialogClose} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">Adding floor plans</DialogTitle>
      <DialogContent>
        <DialogContentText>Write down the name of your new floor plan.</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="fp_name"
          label="Floor plan name"
          type="text"
          fullWidth
          onBlur={(event) => {
            floorplan_input = event.target.value;
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={dialogClose} color="primary">
          Cancel
        </Button>
        <Button
          onClick={(_) => {
            addFloorplan();
          }}
          color="primary"
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
